<template>
    <!--begin::Dashboard-->
    <div class="row">
        <div
            class="col-12 aos-init aos-animate content mx-auto"
            :class="totalSumm !== 0 ? 'mb-50' : ''"
            data-aos="fade-up"
            data-aos-delay="100"
        >
            <div class="titulo-pagina mb-10 text-lg-left text-sm-center">
                <span>PERFIL DE </span><span class="text-uppercase">{{client.codigoRol}}</span>
            </div>
            <div class="card-femsa d-none d-sm-block">
                <div
                    class="card-body row justify-content-between align-items-center py-6 px-8"
                >
                    <div class="col-4 col-lg-4 d-none d-sm-block">
                        <div class="card-femsa-titulo">NOMBRE EMPRESA</div>
                        <div class="card-femsa-sub-titulo mt-4">
                            {{ client.nombreEmpresa }}
                        </div>
                    </div>
                    <div class="col-4 col-lg-2 d-none d-sm-block">
                        <div class="card-femsa-titulo">RUT EMPRESA</div>
                        <div class="card-femsa-sub-titulo mt-4">
                            {{ client.rutEmpresa }}-{{ client.rutEmpresaDv }}
                        </div>
                    </div>
                    <div class="col-12 col-lg-3 mt-5 mt-lg-0 d-none d-sm-block">
                        <div class="card-femsa-titulo">CORREO CORPORATIVO</div>
                        <div class="card-femsa-sub-titulo mt-4">
                            {{ client.email }}
                        </div>
                    </div>

                    <div class="col-12 col-lg-3 mt-5 mt-lg-0 total-deuda">
                        <div class="row">
                            <div class="col-12 col-md-6 col-lg-6 border-right">
                                <div class="total-deuda-titulo text-uppercase font-weight-normal fs-15">DEUDA TOTAL</div>
                                <div class="total-deuda-monto mt-1 fs-15">
                                    {{ deudaTotal | currency }}
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-6">
                                <div class="total-deuda-titulo text-uppercase font-weight-normal fs-15 d-flex justify-content-center">Saldo disponible <img class="info-Img" src="/media/img/infoImg.png" data-toggle="tooltip" title="Este saldo representa el dinero real que tienes a tu disposición para gastar o retirar en un momento específico."></div>
                                <div class="total-deuda-monto mt-1 fs-15">
                                    {{ saldoDisponible | currency }}
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-block d-sm-none total-deuda">
                <div class="row">
                    <div class="col-12 col-md-6 col-lg-6 border-right">
                        <div class="total-deuda-titulo text-uppercase font-weight-normal fs-15">DEUDA TOTAL</div>
                        <div class="total-deuda-monto mt-1 fs-15">
                            {{ deudaTotal | currency }}
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-6">
                        <div class="total-deuda-titulo text-uppercase font-weight-normal fs-15 d-flex justify-content-center">Saldo disponible <img class="info-Img" src="/media/img/infoImg.png" data-toggle="tooltip" title="Este saldo representa el dinero real que tienes a tu disposición para gastar o retirar en un momento específico."></div>
                        <div class="total-deuda-monto mt-1 fs-15">
                            {{ saldoDisponible | currency }}
                            
                        </div>
                    </div>
                </div>
            </div>

            <div class="titulo-pagina mt-10 mb-10 text-lg-left text-sm-center">
                <span>RESUMEN DE </span><span>DOCUMENTOS</span>
            </div>
            <!-- <h2>búsqueda avanzada</h2> -->
            <div class="card-femsa mb-5 d-flex flex-row mb-4">
                <div
                    class="card-body row justify-content-between align-items-center py-3 px-8"
                >
                    <b-form
                        action=""
                        class="d-search"
                        @submit.stop.prevent="onSubmit"
                    >
                        <div class="row">
                            <div class="col-sm-12 col-lg-3 mt-5 mt-lg-0">
                                <label for="inputDoc" class="label-femsa mb-2"
                                    >Nº Documento</label
                                >
                                <b-form-input
                                    class="form-control form-control-femsa"
                                    id="info-documento"
                                    name="documento"
                                    v-model="$v.form.documento.$model"
                                    :state="validateState('documento')"
                                    aria-describedby="info-documento-mensaje-validacion"
                                    placeholder="Nº documento"
                                    type="number"
                                ></b-form-input>
                            </div>
                            <div class="col-sm-12 col-lg-3 mt-5 mt-lg-0">
                                <label
                                    for="inputSucursal"
                                    class="label-femsa mb-2"
                                    >Sucursal</label
                                >
                                <b-form-select
                                    v-model="sucursal"
                                    :options="sucursales"
                                    value-field="nombreSucursal"
                                    text-field="nombreSucursal"
                                    class="custom-select form-control-femsa"
                                >
                                    <option value="">Todas</option>
                                </b-form-select>
                            </div>
                            <div class="col-sm-12 col-lg-3 mt-5 mt-lg-0">
                                <label for="startDate" class="label-femsa mb-2"
                                    >Periodo de vencimiento</label
                                >
                                <v-menu
                                    v-model="menu1"
                                    :close-on-content-click="false"
                                    max-width="290"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            :value="
                                                computedDateFormattedMomentjs
                                            "
                                            clearable
                                            class="form-control v-input-femsa"
                                            placeholder="Desde"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            @click:clear="desde = null"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="desde"
                                        @change="menu1 = false"
                                        locale="es-cl"
                                        :first-day-of-week="1"
                                    ></v-date-picker>
                                </v-menu>
                            </div>
                            <div class="col-sm-12 col-lg-3 mt-5 mt-lg-0">
                                <label
                                    for="endDate"
                                    class="label-femsa mb-7"
                                ></label>
                                <v-menu
                                    v-model="menu2"
                                    :close-on-content-click="false"
                                    max-width="290"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            :value="
                                                computedDateFormattedMomentjs2
                                            "
                                            clearable
                                            class="form-control v-input-femsa"
                                            placeholder="Hasta"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            @click:clear="hasta = null"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="hasta"
                                        @change="menu2 = false"
                                        locale="es-cl"
                                        :first-day-of-week="1"
                                    ></v-date-picker>
                                </v-menu>
                            </div>
                        </div>

                        <div class="d-flex justify-content-end mt-5">
                            <button
                                class="btn-primary-femsa col-sm offset-lg-10 offset-xl-10"
                                ref="kt_login_signin_submit"
                            >
                                Buscar
                            </button>
                        </div>
                    </b-form>
                </div>
            </div>

            <div class="titulo-pagina mt-10 mb-10 text-lg-left text-sm-center">
                <span>DOCUMENTOS </span><span>PENDIENTES</span>
            </div>
            <div
                class="d-flex flex-column flex-sm-row justify-content-start justify-content-sm-between align-items-center card-azul-femsa py-4 px-3 mb-7 row-gap-20"
            >
                
                <div class="checkbox mb-1 mt-1 ml-7">
                    <label class="label-azul">
                        <b-form-checkbox v-model="selectAll"
                            >Seleccionar todos</b-form-checkbox
                        >
                    </label>
                </div>

                <div class="d-none d-sm-block">
                    <download-excel
                        class="btn-second-femsa w-200px d-flex justify-content-center cursor-pointer"
                        :data="documents"
                        :fields="json_fields"
                        worksheet="Documentos"
                        name="Documentos.xls"
                    >
                        Descargar
                    </download-excel>
                </div>

                <div class="d-block d-sm-none w-100">
                    <download-excel
                        class="btn-second-femsa w-100 d-flex justify-content-center cursor-pointer"
                        :data="documents"
                        :fields="json_fields"
                        worksheet="Documentos"
                        name="Documentos.xls"
                    >
                        Descargar
                    </download-excel>
                </div>
            </div>
            <b-overlay :show="loading" varant="white" rounded="sm">
                <div v-if="visiblePages.length <= 0" class="d-flex justify-content-center card-femsa-titulo">No tiene documentos pendientes</div>
                <template
                    v-for="(item, index) in visiblePages"
                    
                >
                    <div
                        v-bind:key="index"
                        class="card-femsa d-flex justify-content-center justify-content-md-between flex-row mb-4"
                    >
                        <!-- <div
                            class="d-flex justify-content-between align-items-center w-100 row"
                        > -->

                        <div
                            class="row justify-content-between align-items-center w-100 row-gap-20"
                        >
                            <div
                                class="col-6 col-sm-1 checkbox d-flex justify-content-center"
                            >
                                <span>
                                    <b-form-checkbox
                                        v-model="item.seleccionado"
                                    ></b-form-checkbox>
                                </span>
                            </div>
                            <div class="col-6 col-sm text-center">
                                <div
                                    for="inputFn"
                                    class="card-femsa-titulo mb-4"
                                >
                                    Doc. Nº
                                </div>
                                <span
                                    id="inputFn"
                                    class="card-femsa-sub-titulo text-center"
                                    >{{ item.numeroDocumento }}</span
                                >
                                <span class="m-2" v-on:click="getPdfFactura(item)"><i class="far fa-file-pdf text-danger cursor-pointer"></i></span>
                            </div>
                            <div class="col d-none d-md-block text-center">
                                <div
                                    for="inputFn"
                                    class="card-femsa-titulo mb-4"
                                >
                                    Tipo
                                </div>
                                <span
                                    id="inputFn"
                                    class="card-femsa-sub-titulo"
                                    >{{ item.tipoDocumento }}</span
                                >
                            </div>
                            <div class="col-6 col-sm expired">
                                <div
                                    for="inputDateLast"
                                    class="card-femsa-titulo mb-2 text-center"
                                >
                                    Vencimiento
                                </div>
                                <span
                                    class="d-flex justify-content-center badge-femsa w-100"
                                    id="inputDateLast"
                                    :class="estiloItem(item)"
                                >
                                    {{
                                        item.fechaVencimiento | formatDate
                                    }}</span
                                >
                            </div>
                            <div
                                class="col d-none d-md-block text-center branch"
                            >
                                <div
                                    for="inputLocale"
                                    class="card-femsa-titulo mb-4"
                                >
                                    sucursal
                                </div>
                                <span
                                    id="inputLocale"
                                    class="card-femsa-sub-titulo"
                                    >{{ item.sucursal }}</span
                                >
                            </div>
                            <div
                                class="col d-none d-md-block text-center ammount"
                            >
                                <div
                                    for="inputMount"
                                    class="card-femsa-titulo mb-4"
                                >
                                    monto total
                                </div>
                                <span
                                    id="inputMount"
                                    class="card-femsa-sub-titulo"
                                    >{{ item.monto | currency }}</span
                                >
                            </div>
                            <div
                                class="col d-none d-md-block text-center payment"
                            >
                                <div
                                    for="inputCredited"
                                    class="card-femsa-titulo mb-4"
                                >
                                    abonado
                                </div>
                                <span
                                    id="inputCredited"
                                    class="card-femsa-sub-titulo"
                                    >{{ item.abonado | currency }}</span
                                >
                            </div>
                            <div
                                class="col-6 col-sm text-center input-payment"
                            >
                                <div
                                    for="inputCredit"
                                    class="credit card-femsa-titulo mb-2"
                                >
                                    <!--div class="custom-control custom-switch d-flex flex-row align-self-end">
                    <b-form-checkbox v-model="item.permiteAbonar" class="xcustom-control-input" :disabled="!item.seleccionado"></b-form-checkbox>
                    <label class="custom-control-label" for="customSwitch1">Abonar</label>
                  </div-->
                                    Monto a Pagar
                                </div>
                                <money
                                    v-model="item.saldo"
                                    v-bind="money"
                                    class="badge-femsa badge-azul w-100"
                                    :disabled="!item.seleccionado"
                                ></money>
                                <div
                                    class="error"
                                    v-if="
                                        !$v.documents.$each[index].saldo
                                            .required
                                    "
                                >
                                    Requerido
                                </div>
                                <div
                                    class="error"
                                    v-if="
                                        !$v.documents.$each[index].saldo
                                            .maxespecial
                                    "
                                >
                                    Supera monto documento
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <!-- <v-pagination
                    v-model="page"
                    :length="Math.ceil(documents.length / perPage)"
                ></v-pagination> -->
                <!-- <div
                    class="card card-total card-row d-flex flex-row align-items-center justify-content-end mb-4"
                >
                    <label>Total a pagar</label>
                    <h4 class="m-0 pl-5">{{ totalSumm | currency }}</h4>
                </div> -->
            </b-overlay>
        </div>
        <div 
            class="contenedor-medios-de-pago d-flex flex-column justify-content-center"
            v-if="totalSumm !== 0"
        >
            <div class="d-flex justify-content-center mb-5">
                <di class="d-flex badge-femsa badge-azul-oscuro">
                    <div>TOTAL A PAGAR</div>
                    <div class="ml-5 font-weight-bold">
                        {{ totalSumm | currency }}
                    </div>
                </di>
            </div>
            <!--div class="card-femsa-titulo d-flex justify-content-center mt-5">
                Medios de Pago
            </div-->
            <div
                class="d-none card-bancos contenedor-bancos row justify-content-center"
            >
                <template v-for="(item, x) in methods">
                    <div v-bind:key="x + '-pay'">
                        <selectable-plan
                            :plan-codigo="item.codigo"
                            v-model="codigoMedioPago"
                        ></selectable-plan>
                    </div>
                </template>
            </div>
            <form
                id="irapagar"
                name="irapagar"
                method="post"
                :action="order.payUrl"
            >
                <input
                    type="hidden"
                    name="guidTransaccion"
                    :value="order.guidTransaccion"
                />
                <input
                    type="hidden"
                    name="idEntidadRecaudadora"
                    :value="order.idEntidad"
                />
                <input
                    type="hidden"
                    name="codigoAplicacion"
                    :value="order.codigoAplicacion"
                />
                <input type="hidden" name="rutCliente" :value="rutCliente" />
                <input type="hidden" name="monto" :value="order.monto" />
            </form>
            <div class="d-sm-flex justify-content-center d-none d-sm-block">
                <button
                    v-on:click.prevent="getOrder()"
                    :disabled="totalSumm <= 0"
                    class="btn-second-femsa w-200px mr-10"
                >
                    Pagar
                </button>
                <button class="btn-outline-femsa w-200px" @click="cancelar">
                    Cancelar
                </button>
            </div>

            <div class="d-block d-sm-none">
                <button
                    v-on:click.prevent="getOrder()"
                    :disabled="totalSumm <= 0 "
                    class="btn-second-femsa w-100"
                >
                    Pagar
                </button>
                <button class="btn-outline-femsa w-100 mt-5" @click="cancelar">
                    Cancelar
                </button>
            </div>
        </div>
    </div>

    <!--end::Dashboard-->
</template>

<script>
import { mapState } from "vuex";
import { GET_DOCUMENTS, GET_BALANCES } from "@/core/services/store/client.module";
import {
    GET_METHODS,
    CREATE_ORDER, GET_PDF_FACTURA
} from "@/core/services/store/payment.module";
import SelectablePlan from "@/view/content/widgets/payments/PaymentMethods.vue";
//import VueAos from 'vue-aos'
//import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { Money } from "v-money";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { minLength } from "vuelidate/lib/validators";

import moment from "moment";
moment.locale("es");
const notaCredito = "CM";
export default {
    mixins: [validationMixin],
    name: "dashboard",
    components: { Money, SelectablePlan },
    data() {
        return {
            page: 1,
            perPage: 9999999999,
            selected: [],
            loading: true,
            menu2: false,
            menu1: false,
            hasta: null,
            desde: null,
            sucursal: "",
            codigoMedioPago: "",
            order: {},
            form: {
                documento: "",
                desde: "",
                hasta: "",
            },
            deudaTotal: 0,
            saldoDisponible:0,
            money: {
                decimal: ",",
                thousands: ".",
                prefix: "$ ",
                suffix: "",
                precision: 0,
                masked: false,
            },

            json_fields: {
                Documento: "numeroDocumento",
                Monto: "monto",
                Abonado: "abonado",
                Saldo: "saldo",
                Sucursal: "sucursal",
                Vencimiento: "fechaVencimiento",
            },
        };
    },
    mounted() {
        this.getDocuments();
        this.getBalances();
        //this.getMethods();
    },
    validations: {
        form: {
            documento: {
                minLength: minLength(3),
            },
            desde: {},
            hasta: {},
        },
        documents: {
            $each: {
                saldo: {
                    required,
                    maxespecial: function (misaldo, item) {
                        if (item.codigoTipoDocumento != notaCredito)
                            return (
                                (misaldo <= item.deuda && misaldo > 0) ||
                                !item.seleccionado
                            );
                        else
                            return (
                                (misaldo >= item.deuda && misaldo < 0) ||
                                !item.seleccionado
                            );
                    },
                },
                monto: { required },
                abonado: required,
                sucursal: required,
                permiteAbonar: required,
                numeroDocumento: required,
                seleccionado: required,
            },
        },
    },
    methods: {
        cancelar() {
            this.selectAll = false;
        },
        validateState(name) {
            const { $dirty, $error } = this.$v.form[name];
            return $dirty ? !$error : null;
        },
        resetForm() {
            this.form = {
                documento: null,
                sucursal: null,
                desde: null,
                hasta: null,
            };

            this.$nextTick(() => {
                this.$v.$reset();
            });
        },
        onSubmit() {
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }

            const documento = this.$v.form.documento.$model;
            const sucursal = this.sucursal;
            const desde = this.desde;
            const hasta = this.hasta;

            // set spinner to submit button
            const submitButton = this.$refs["kt_login_signin_submit"];
            submitButton.classList.add(
                "spinner",
                "spinner-light",
                "spinner-right"
            );

            // dummy delay
            setTimeout(() => {
                // send login request
                this.getDocuments({
                    params: { documento, sucursal, desde, hasta },
                });
                submitButton.classList.remove(
                    "spinner",
                    "spinner-light",
                    "spinner-right"
                );
            }, 500);
        },
        getDocuments(params = null) {
            this.$Progress.start();
            this.$store
                .dispatch(GET_DOCUMENTS, params)
                .then((response) => {
                    (this.deudaTotal = response.totalDeuda),
                        this.$Progress.finish(),
                        (this.loading = false);
                })
                .catch(function () {
                    this.$Progress.finish(), (this.loading = false);
                });
        },
        getBalances(params = null) {
            this.$Progress.start();
            this.$store
                .dispatch(GET_BALANCES, params)
                .then((response) => {
                    (this.saldoDisponible = response.totalSaldoAFavor),
                        this.$Progress.finish(),
                        (this.loading = false);
                })
                .catch(function () {
                    this.$Progress.finish(), (this.loading = false);
                });
        },
        getMethods() {
            this.$Progress.start();
            this.$store.dispatch(GET_METHODS).then(() => {
                this.$Progress.finish();
            });
        },
        getPdfFactura(item) {
            this.$Progress.start();
        
                this.$store
                .dispatch(GET_PDF_FACTURA,item)
                .then((response) => {
                if(response.codigo == 0 && response.mensaje)
                    { 
                    window.open(response.mensaje,'_blank')
                    }else{
        this.$bvToast.toast(`Documento no encontrado.`, {
                title: 'Error Documento',
                autoHideDelay: 5000,
                variant: "danger",
                toaster:"b-toaster-top-right",
                appendToast: true
            })
                    }
                    this.loading=false
                });
            
            },
        getOrder() {
            this.$v.documents.$touch();
            if (this.$v.documents.$anyError) {
                return;
            }
            const t = this;
            this.$store
                .dispatch(CREATE_ORDER, {
                    codigoMedioPago: this.codigoMedioPago,
                    Detalles: this.documents,
                })
                .then(function (response) {
                    t.order = response;
                    t.$router.push({ name: "confirm-pay", params: { codigo: response.tokenOrden }  });
                    /*setTimeout(function () {
                        if (t.order.nuevaVentana) {
                            var left = screen.width / 2 - 800 / 2;
                            var top = screen.height / 2 - 600 / 2;
                            window.open(
                                "",
                                "formpopup",
                                "width=800,height=600,resizeable,scrollbars, top=" +
                                    top +
                                    ", left=" +
                                    left
                            );
                            document.getElementById("irapagar").target =
                                "formpopup";
                        }
                        document.getElementById("irapagar").submit();
                    }, 10);*/
                });
        },
        onUpdatePay(activePay) {
            this.codigoMedioPago = activePay;
        },
        estiloItem(item) {
            const hoy = new Date();
            var date1 = moment(hoy).format("YYYY-MM-DD");
            var date2 = moment(item.fechaVencimiento).format("YYYY-MM-DD");
            if (moment(date1).isBefore(date2)) {
                return "no-vencida";
            } else {
                return "vencida";
            }
        },
    },
    filters: {
        formatDate(value) {
            const duration = moment(value).format("DD/MM/yyyy");
            return `${duration}`;
        },

        formatTime(value) {
            const hora = moment(value).format("HH:mm:ss");
            return `${hora}`;
        },
    },
    computed: {
        visiblePages() {
            return this.documents.slice(
                (this.page - 1) * this.perPage,
                this.page * this.perPage
            );
        },
        selectAll: {
            get() {
                if (this.documents && this.documents.length > 0) {
                    // A users array exists with at least one item
                    let allChecked = true;

                    for (const user of this.documents) {
                        if (!this.selected.includes(user.id)) {
                            allChecked = false; // If even one is not included in array
                        }

                        // Break out of loop if mismatch already found
                        if (!allChecked) break;
                    }

                    return allChecked;
                }

                return false;
            },
            set(value) {
                if (value) {
                    // this.selected = this.documents.map((doc) => doc.id);
                    // this.documents.forEach((doc) => (doc.seleccionado = true));
                    const checked = [];
                    this.documents.forEach((item) => {
                        checked.push(item.id);
                        item.seleccionado = value;
                    });

                    this.selected = checked;
                } else {
                    this.selected = [];
                    this.documents.forEach((doc) => (doc.seleccionado = false));
                }
            },
            // set(value) {
            //     const checked = [];
            //     this.documents.forEach((item) => {
            //         checked.push(item.id);
            //         item.seleccionado = value;
            //     });

            //     this.selected = checked;
            // },
        },
        ...mapState({
            documents: (state) => state.client.documents,
            balances: (state) => state.client.balances,
            sucursales: (state) => state.client.branchs,
            methods: (state) => state.payment.methods,
            errors: (state) => state.errors,
            client: (state) => state.auth.user,
            totalSumm: function () {
                return this.documents
                    .filter((item) => item.seleccionado)
                    .reduce(function (total, item) {
                        return total + item.saldo;
                    }, 0);
            },
            totalDeuda2: function () {
                return this.documents.reduce(function (total, item) {
                    return total + (item.monto - item.abonado);
                }, 0);
            },
            rutCliente: function () {
                return `${this.order.rutEmpresa}-${this.order.dvEmpresa}`;
            },
            computedDateFormattedMomentjs() {
                return this.desde
                    ? moment(this.desde).format("DD/MM/yyyy")
                    : "";
            },
            computedDateFormattedMomentjs2() {
                return this.hasta
                    ? moment(this.hasta).format("DD/MM/yyyy")
                    : "";
            },
        }),
    },
};
</script>
<style>
.custom-checkbox label {
    margin-top: 5px;
    display: block;
}
.custom-control-label::before {
    position: absolute;
    top: 0rem !important;
}
.custom-control-label::after {
    top: 0rem !important;
}
.b-form-datepicker {
    min-width: 130px;
}
.b-form-datepicker label {
    padding-bottom: 3px !important;
    padding-top: 6px;
    text-transform: none;
    white-space: nowrap !important;
    font-size: 1rem !important;
}
.b-form-datepicker .btn:not(:disabled):not(.disabled) {
    cursor: pointer;
    padding: 10px 5px;
}
.d-content-full {
    width: 100%;
}
@keyframes float {
    0% {
        box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
        transform: translatey(0px);
    }
    50% {
        box-shadow: 0 25px 15px 0px rgba(0, 0, 0, 0.2);
        transform: translatey(-20px);
    }
    100% {
        box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
        transform: translatey(0px);
    }
}
._levitar {
    margin-top: 20px;
    animation: float 6s ease-in-out infinite;
}
.download {
    cursor: pointer;
    text-align: right;
    margin-right: 10px;
    display: table-cell;
    float: right !important;
}
.document {
    width: 80px;
}
.document-type {
    width: 90px;
}
.expired {
    width: 110px;
}
.branch {
    width: 110px;
}
.ammount {
    width: 105px;
}
.payment {
    width: 105px;
}
.input-payment {
    width: 170px;
}
.error {
    color: Red;
    font-size: 0.65em;
}
</style>
